import React from 'react';
import './index.css'
import ReactDOM from 'react-dom';
import { FluentProvider, teamsDarkTheme } from '@fluentui/react-components';

import App from './App';

ReactDOM.render(
  <FluentProvider theme={teamsDarkTheme}>
    <App />
  </FluentProvider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

